import React from "react";
import { formatDateOnly } from "@/lib/date";
import { fmtClock } from "@/components/shownotes/meta";

const W = 128, H = 30, P = 4;

// Tiny SVG line of a scene's run times, oldest → newest.
export default function Sparkline({ points, color = "#64748b", testId }) {
  const vals = points.map((p) => p.seconds);
  const lo = Math.min(...vals), hi = Math.max(...vals);
  const x = (i) => (points.length === 1 ? W / 2 : P + (i * (W - 2 * P)) / (points.length - 1));
  const y = (v) => (hi === lo ? H / 2 : H - P - ((v - lo) * (H - 2 * P)) / (hi - lo));
  const line = points.map((p, i) => `${x(i)},${y(p.seconds)}`).join(" ");
  return (
    <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} className="shrink-0 overflow-visible" data-testid={testId}>
      {points.length > 1 && <polyline points={line} fill="none" stroke={color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />}
      {points.map((p, i) => (
        <circle key={i} cx={x(i)} cy={y(p.seconds)} r={i === points.length - 1 ? 3.5 : 2} fill={i === points.length - 1 ? color : "#fff"} stroke={color} strokeWidth="1.5">
          <title>{`${formatDateOnly(p.date)}${p.report_number ? ` · #${p.report_number}` : ""}: ${fmtClock(p.seconds)}`}</title>
        </circle>
      ))}
    </svg>
  );
}
